import styled from 'styled-components';

export const BkngDetailMainWrap = styled.div(
    props => `
        width: 100%;
        display: flex;
        flex-direction: column;
        background-color: ${props.theme.colors.white.base};
        padding: ${props.theme.spacing.large.l15} ${props.theme.spacing.large.l25};
        border-radius: ${props.theme.misc.borderRadius.base};
        box-shadow: 0 4px 8px 0 rgba(138, 107, 118, 0.08);
        margin-bottom: ${props.theme.spacing.large.l15};
    `
);

export const BkngDetailOuterWrap = styled.div(
    props => `
        width:100%;
        display: flex;
    `
);

export const BkngDetailInnerWrap = styled.div(
    props => `
        display: flex;
        flex-direction: column;
        width:100%;
        padding-right: ${props.theme.spacing.large.l25};
        padding-bottom:  ${props.theme.spacing.large.l15};
    `
);

export const HtlNameStatusWrap = styled.div(
    props => `
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
    `
)

export const BkngHotelStarWrap = styled.div(
    props => `
        display: flex;
        align-items: center;
    `
);

export const HtlStarWrap = styled.p(
    props => `
        display: flex;
        align-self: flex-start;
        border: 1px solid #8b572a;
        border-radius: ${props.theme.misc.borderRadius.base};
        padding: ${props.theme.spacing.small.s4} ${props.theme.spacing.small.s8};
        font-size: ${props.theme.font.small.font11};
        color: ${props.theme.colors.yellow.dark8b};
        font-weight: ${props.theme.font.fontWeight.bold};
        text-transform: uppercase;
    `
);

export const BkngHotelNameDetails = styled.div(
    props => `
        display: flex;
        flex-direction: column;
        padding: ${props.theme.spacing.base} 0;
        border-bottom: 1px solid ${props.theme.colors.grey.lighte7};
    `
);

export const BkngHtlNameText = styled.div(
    props => `
        font-size: ${props.theme.font.large.font21};
        color: ${props.theme.colors.black.base};
        font-weight: ${props.theme.font.fontWeight.bold};
    `
);

export const Status = styled.span(
    props => `
      background-color: ${props.theme.colors.yellow.bgLightff};
      padding: ${props.theme.spacing.small.s2} ${props.theme.spacing.small.s8};
      border-radius: ${props.theme.misc.borderRadius.base};
      font-size: ${props.theme.font.small.font11};
      color: ${props.theme.colors.yellow.darkcf};
      font-weight: ${props.theme.font.fontWeight.bold};
      margin-left: ${props.theme.spacing.base};
      display: flex;
      justify-content: flex-end;
    `
);

export const BkngHtlAddressText = styled.p(
    props => `
        font-size: ${props.theme.font.large.font14};
        color: ${props.theme.colors.grey.base}
        padding: ${props.theme.spacing.small.s8} 0;
    `
);

export const HtlContantInfoWrap = styled.div(
    props => `
        width:100%;
        display: flex;
        aling-items: center;
    `
);

export const ContactInfoIconWrap = styled.div(
  props => `
    width:2.4rem;
    height: 2.4rem;
    marign-right: ${props.theme.spacing.small.s2};
  `
);

export const ContactInfoText = styled.p(
    props => `
        font-size: ${props.theme.font.large.font14};
        color: ${props.theme.colors.grey.base};
        font-weight: ${props.theme.font.fontWeight.bold};
    `
);

export const BkngDetailCheckInfo = styled.div(
    props => `
        width:100%;
        display: flex;
        padding: ${props.theme.spacing.large.l13} 0;
        align-items: center;
        justify-content: space-between;
    `
);

export const CheckInfoWrap = styled.div(
    props => `
        display: flex;
        flex-direction: column;
    `
);

export const CheckInfoHeadText = styled.p(
    props => `
        font-size: ${props.theme.font.base};
        color: ${props.theme.colors.grey.base1};
        text-transform: uppercase;
    `
);

export const CheckInfoDateWrap = styled.div(
    props => `
        display: flex;
        padding-top: ${props.theme.spacing.small.s7};
        align-items:center;
    `
);

export const CheckInfoDateText = styled.p(
    props => `
        font-size: ${props.theme.font.large.font40};
        color: ${props.theme.colors.black.base};
        font-weight: ${props.theme.font.fontWeight.bold};
    `
);

export const CheckDateInnerWrap = styled.div(
    props => `
        display: flex;
        flex-direction: column;
        padding-left: ${props.theme.spacing.small.s5};
    `
);

export const CheckDateMonthText = styled.p(
    props => `
        font-size: ${props.theme.font.large.font14};
        color: ${props.theme.colors.grey.base};
    `
);

export const CheckTimeText = styled.p(
    props => `
        font-size: ${props.theme.font.large.font14};
        color: ${props.theme.colors.black.base};
        font-weight: ${props.theme.font.fontWeight.bold};
    `
);

export const StayNighsWrap = styled.div(
    props => `
        display: flex;
        padding: 0 ${props.theme.spacing.large.l40};
        position: relative;
    `
);

export const DiagonalLine =  styled.div(
    props => `
        width:50%;
        display: flex;
        height:1px;
        background-color: ${props.theme.colors.grey.base1};
        position: absolute;
        top: 1rem;
        left:3.7rem;
        transform: rotate(-45deg);
    `
);

export const NightStayText = styled.p(
    props => `
        background-color: ${props.theme.colors.grey.base1};
        padding: ${props.theme.spacing.small.s2} ${props.theme.spacing.base};
        border-radius: 1rem;
        font-size: ${props.theme.font.base};
        color: ${props.theme.colors.white.base};
        font-weight: ${props.theme.font.fontWeight.bold};
        text-transform: uppercase;
        z-index: 1;
    `
);

export const RoomTypeInfoWrap = styled.div(
    props => `
        width:100%;
        display: flex;
        flex-direction: column;
    `
);

export const RoomTypeInfoHeadText = styled.p(
    props => `
        font-size: ${props.theme.font.base};
        color: ${props.theme.colors.grey.base1};
        text-transform: uppercase;
    `
);

export const RoomInfoInnerWrap  = styled.div(
    props => `
        width:100%;
        display: flex;
        align-items: flex-start;
        padding-top: ${props.theme.spacing.small.s5};
        flex-direction: column;
    `
);

export const RoomTypeText = styled.p(
    props => `
        font-size: ${props.theme.font.large.font16};
        color: ${props.theme.colors.grey.base};
        font-weight: ${props.theme.font.fontWeight.bold};
    `
);

export const RoomAmenitiesText = styled.p(
    props => `
        font-size: ${props.theme.font.large.font14};
        color: ${props.theme.colors.green.base};
    `
);


export const BkngHotelImgWrap = styled.div(
    props => `
        // width:25%;
        display: flex;
        flex-direction: column;
        align-self: flex-end;
        position: relative;
        margin-bottom: ${props.theme.spacing.base};
    `
);

export const HotelImgTrip = styled.img(
    props => `
        width: 20.8rem;
        height: 16.6rem;
        border-radius: ${props.theme.misc.borderRadius.base};
        margin-bottom: ${props.theme.spacing.large.l20};
    `
);

export const ImageTextWrapper = styled.div(
  props => `
    display: block;
    position: absolute;
    bottom: 0;
    width: 100%;
    color: ${props.theme.colors.white.base};
    background: ${props.theme.colors.black.base};
    padding: ${props.theme.spacing.base};
    border-radius: 0 0 ${props.theme.misc.borderRadius.base} ${props.theme.misc.borderRadius.base};
    font-weight: ${props.theme.font.fontWeight.bold};
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  `
);

export const LocationImg = styled.img(
    props => `
        width: 18.8rem;
        height: 6rem;
        border-radius: ${props.theme.misc.borderRadius.base};
        margin-bottom: ${props.theme.spacing.large.l20};
    `
);
